import type { Point, PositionError } from "@typings/foodMapTypes";
import { useEffect, useState } from "react";

export default function useUserLocation() {
  const [location, setLocation] = useState<Point | null>(null);
  const [error, setError] = useState<
    PositionError | GeolocationPositionError | null
  >(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchLocation = () => {
    const successCallback = (position: GeolocationPosition) => {
      setLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
      setLoading(false);
    };

    const errorCallback = (error: GeolocationPositionError) => {
      console.error("Error obtaining location:", error);
      setError(error);
      setLoading(false);
    };

    setLoading(true);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    } else {
      alert("Geolocation is not supported by this browser.");
      setError({
        code: 400,
        message: "Geolocation is not supported by this browser.",
      });
      setLoading(false);
    }
  };

  // Called when user clicks “Allow Location Access”
  const requestLocation = () => {
    fetchLocation();
  };

  // Auto-fetch location if permission is already granted / rejected
  useEffect(() => {
    if ("permissions" in navigator) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permissionStatus) => {
          if (
            permissionStatus.state === "granted" ||
            permissionStatus.state === "denied"
          ) {
            fetchLocation();
          }
        })
        .catch((err: unknown) => {
          console.error("Permission check failed:", err);
        });
    }
  }, []);

  return { location, error, requestLocation, loading };
}
